import React, { useEffect, useState, useMemo } from "react";
import {
  Layout,
  Menu,
  Modal,
  Button,
  Dropdown,
  Avatar,
  Typography,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { Box, createTheme, Drawer, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import banner from "../../images/Portal-Banner.png";
import { menuItems } from "./sideMenuItems";
import { useMediaQuery } from "@mui/material";
import {
  clearAllSessionStorage,
  getSessionStorage,
} from "../../helpers/session_storage";

const { Header, Content, Sider } = Layout;
const SideLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [user, setUser] = useState({});

  const [openKeys, setOpenKeys] = useState([]);
  const selectedKey = useMemo(() => location.pathname, [location]);
  const theme = createTheme();
  const isMd = useMediaQuery(() => theme.breakpoints.down("md"));
  useEffect(() => {
    const foundKey = menuItems.find((item) =>
      item.children.some((child) => child.key === selectedKey)
    )?.key;
    if (foundKey) setOpenKeys([foundKey]);
  }, [selectedKey]);
  useEffect(() => {
    const storedUser = getSessionStorage("user");
    console.log(storedUser);

    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  const handleLogout = () => {
    clearAllSessionStorage();
    navigate("/");
  };

  const toggleDrawer = (open) => () => setDrawerOpen(open);

  const showLogoutConfirm = () =>
    Modal.confirm({
      title: "Are you sure you want to Logout?",
      okText: "Yes",
      cancelText: "No",
      icon: <LogoutOutlined />,
      onOk: handleLogout,
    });

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const renderMenuItems = (items) =>
    items.map(({ key, icon, title, children }) => (
      <Menu.SubMenu key={key} icon={icon} title={title}>
        {children.map(({ key: childKey, label }) => (
          <Menu.Item key={childKey}>
            <Link to={childKey} onClick={() => toggleDrawer(false)()}>
              {label}
            </Link>
          </Menu.Item>
        ))}
      </Menu.SubMenu>
    ));
  const menu = (
    <Menu>
      {user?.isOfficer === true ? (
        <>
          <Menu.Item disabled key="designation">
            <Typography.Text type="secondary">
              {(user?.designation_name ?? "DESIGNATION") +
                " / " +
                (user?.deeoffice_name ||
                  user?.squad_name ||
                  user?.talukname ||
                  "CORPERATE")}
            </Typography.Text>
          </Menu.Item>{" "}
          <Menu.Divider />
        </>
      ) : (
        <></>
      )}

      <Menu.Item key="logout">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            style={{ paddingInline: "15px", fontSize: "15px", width: "100%" }}
            onClick={showLogoutConfirm}
          >
            Logout
          </Button>
        </div>
      </Menu.Item>
    </Menu>
  );
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          height: 80,
          boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            display: { md: "flex", xs: "none" },
            alignItems: "center",
            gap: 2,
          }}
        >
          <img src={banner} alt="Logo" style={{ height: 60 }} />
        </Box>

        <IconButton
          sx={{
            display: { md: "none", xs: "flex" },
          }}
          onClick={toggleDrawer(true)}
        >
          <MenuIcon />
        </IconButton>
        <Dropdown overlay={menu} trigger={["click"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar
              src="https://p7.hiclipart.com/preview/636/702/321/computer-icons-user-profile-avatar-black-man.jpg"
              size={30}
              style={{ cursor: "pointer" }}
            />
            <Typography.Text
              strong
              style={{ marginLeft: 8, cursor: "pointer" }}
            >
              {user.name ?? "John Doe"}
            </Typography.Text>
          </div>
        </Dropdown>
      </Header>

      <Layout>
        <Box
          sx={{
            display: { xs: "none", md: "block" },
            backgroundColor: "#001529",
            height: "100vh",
          }}
        >
          <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}
            width={280}
            style={{
              background: "#001529",
              color: "#fff",
              boxShadow: "2px 0 8px rgba(0, 0, 0, 0.15)",
              position: "fixed",
              height: "100vh",
              overflowY: "auto",
            }}
            breakpoint="md"
            trigger={null}
          >
            <div
              style={{
                height: 64,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
              }}
            >
              {collapsed ? (
                <MenuUnfoldOutlined onClick={() => setCollapsed(false)} />
              ) : (
                <MenuFoldOutlined onClick={() => setCollapsed(true)} />
              )}
            </div>
            <Menu
              theme="dark"
              selectedKeys={[selectedKey]}
              openKeys={openKeys}
              mode="inline"
              onOpenChange={onOpenChange}
            >
              {renderMenuItems(menuItems)}
            </Menu>
          </Sider>
        </Box>

        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
          sx={{
            "& .MuiDrawer-paper": { backgroundColor: "#001529", color: "#fff" },
          }}
        >
          <Box sx={{ width: 250 }} role="presentation">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: 2,
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              <img src={banner} alt="Admin Logo" style={{ width: 150 }} />
              <IconButton onClick={toggleDrawer(false)}>
                <CloseIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Box>
            <Menu
              theme="dark"
              selectedKeys={[selectedKey]}
              openKeys={openKeys}
              mode="inline"
              onOpenChange={onOpenChange}
            >
              {renderMenuItems(menuItems)}
            </Menu>
          </Box>
        </Drawer>

        <Layout
          style={{ marginLeft: isMd ? 0 : collapsed ? 80 : 280, padding: 24 }}
        >
          <Content
            style={{
           
              // padding: 24,
              margin: 0,
              minHeight: 280,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default SideLayout;
